export const SampleConstant = '{SampleConstant}';
export const BaseAPIUrl = '{BaseAPIUrl}';
export const SampleId = '{BaseAPIUrl}';
export const VersionId = '{VersionId}';
export const AccountProfileId = '{AccountProfileId}';
export const PreProdUrl = 'https://global-dev.amcom-corp-preprod.amway.net/commyshopas';
export const ListId = '{listId}';
export const EntryId = '{entryId}';
export const MyshopLanding = 'my_shop_landing';
export const ShopId = '{ShopId}';
